import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxGridItem = _resolveComponent("DxGridItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGridRef",
      "data-source": _ctx.dsModule,
      "key-expr": "ID",
      allowColumnReordering: true,
      allowColumnResizing: true,
      "show-borders": true,
      "show-row-lines": true,
      "show-column-lines": false,
      "column-auto-width": true,
      onRowInserting: _ctx.onRowInserting,
      onRowUpdating: _ctx.onRowUpdating,
      onRowRemoving: _ctx.onRowRemoving
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxEditing, {
          mode: "row",
          "allow-updating": true,
          "allow-deleting": true,
          "allow-adding": true
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridItem, { name: "addRowButton" }),
            _createVNode(_component_DxGridItem, { name: "searchPanel" })
          ]),
          _: 1
        }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Cauta..."
        }),
        _createVNode(_component_DxColumn, { "data-field": "Cod" }),
        _createVNode(_component_DxColumn, { "data-field": "Nume" }),
        _createVNode(_component_DxColumn, { "data-field": "Explicatie" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Ordine",
          "data-type": "number",
          width: 90
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowInserting", "onRowUpdating", "onRowRemoving"])
  ]))
}